import { render } from "./ItemDiscountReport.vue?vue&type=template&id=2b7b72f8&scoped=true"
import script from "./ItemDiscountReport.vue?vue&type=script&lang=js"
export * from "./ItemDiscountReport.vue?vue&type=script&lang=js"

import "./ItemDiscountReport.vue?vue&type=style&index=0&id=2b7b72f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7b72f8"]])

export default __exports__